import { Units } from 'uom-units';
import { parseIntegerValue } from 'src/utils/parseIntegervalue.ts';
import { convert } from 'src/modules/user-input/convert.ts';
import { Decimal } from 'decimal.js-light';
import { Unit } from 'uom';
import { BelimoTranslate } from 'src/common/hooks/useBelimoTranslate.ts';

const createItem = (value: string) => ({ raw: [value], localized: [value] });

export const convertVnomMetric = (vnom: string, target: Unit.Unit<'VolumeFlow'>, t: BelimoTranslate) => {
    if (vnom.length === 0) {
        return null;
    }
    if (target.name === Units.CubicMeterPerHour.name) {
        return createItem(vnom);
    }
    try {
        const int = new Decimal(parseIntegerValue(vnom));
        const converted = convert(int.div(1000).toFixed(), Units.CubicMeterPerHour, target);
        return createItem(`${converted} ${t(target.name)}`);
    } catch (e) {
        return createItem(vnom);
    }
};
